import React, { useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { DatePicker, Button } from "antd";
import { useSelector } from "react-redux";
import CondicaExport from "./CondicaExport";
import dayjs from "dayjs";
import moment from "moment";
import { Switch } from "antd";
const { RangePicker } = DatePicker;

function CondicaPanel() {
  const componentRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const [finish, setFinish] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [valeaSpinului, setValeaSpinului] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const settings = useSelector((state) => state.settings);
  const [perCadru, setPerCadru] = useState(true);
  const [vacante, setVacante] = useState(false);
  const [startDateFormat, setStartDateFormat] = useState();
  const [endDateFormat, setEndDateFormat] = useState();
  
  useEffect(() => {
    const styleId = "condica-print-styles";
    let styleElement = document.getElementById(styleId);
    
    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      styleElement.innerHTML = `
        @media print {
          /* Force visibility of all content during print */
          div[style*="opacity: 0"] {
            opacity: 1 !important;
            height: auto !important;
            overflow: visible !important;
          }
          html, body {
            height: 100% !important;
            margin: 0;
            padding: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .ant-table-wrapper {
            overflow: visible !important;
          }
          .ant-table-container {
            overflow: visible !important;
          }
          .ant-table-body {
            overflow: visible !important;
          }
          .ant-table {
            table-layout: auto !important;
            width: 100% !important;
            border-collapse: separate !important;
            border-spacing: 0 !important;
          }
          .ant-table-pagination {
            display: none !important;
          }
          .ant-table-tbody > tr {
            height: auto !important;
            display: table-row !important;
          }
          .ant-table-tbody > tr > td,
          .ant-table-thead > tr > th {
            padding: 15px 10px !important;
            height: auto !important;
            line-height: 1.5 !important;
            vertical-align: middle !important;
            border: 1px solid #000 !important;
            position: relative !important;
            display: table-cell !important;
          }
          .ant-table-thead > tr > th {
            font-weight: bold !important;
            background-color: #f0f0f0 !important;
          }
          table {
            page-break-inside: auto;
            width: 100%;
            border-collapse: separate !important;
            border-spacing: 0 !important;
          }
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
            display: table-row !important;
          }
          td, th {
            padding: 15px 10px !important;
            height: auto !important;
            line-height: 1.5 !important;
            vertical-align: middle !important;
            border: 1px solid #000 !important;
            display: table-cell !important;
          }
          thead {
            display: table-header-group;
          }
          tbody {
            display: table-row-group;
          }
          tfoot {
            display: table-footer-group;
          }
          .print-content {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: static !important;
          }
          .condica-export {
            page-break-inside: auto;
            display: block !important;
            position: static !important;
            left: auto !important;
            visibility: visible !important;
            opacity: 1 !important;
            width: 100% !important;
            height: auto !important;
          }
          .condica-export * {
            visibility: visible !important;
            opacity: 1 !important;
          }
          .condica-export table {
            margin-bottom: 20px !important;
          }
          h3[style*="pageBreakBefore"] {
            page-break-before: always;
          }
          div[style*="pageBreakAfter"] {
            page-break-after: always;
          }
          /* Force visibility for all Ant Design components */
          .ant-table-wrapper,
          .ant-table,
          .ant-table-container,
          .ant-table-content,
          .ant-table-thead,
          .ant-table-tbody,
          .ant-table-tfoot {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: static !important;
            width: 100% !important;
            height: auto !important;
          }
          /* Ensure text content is visible */
          p, h1, h2, h3, h4, h5, h6, span, div {
            color: #000 !important;
            visibility: visible !important;
            opacity: 1 !important;
          }
        }
      `;
      document.head.appendChild(styleElement);
    }
    
    return () => {
      if (styleElement && styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
    };
  }, []);

  const handlePrint = () => {
    const contentElement = componentRef.current;
    
    if (!contentElement || contentElement.innerHTML.length < 1000) {
      alert('Conținutul nu este încărcat complet. Te rugăm să aștepți câteva secunde și încearcă din nou.');
      return;
    }

    // Open print page in new window
    const printWindow = window.open('/condica-print.html', '_blank', 'width=1200,height=800');
    
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        // Send content to print window
        printWindow.postMessage({
          type: 'PRINT_CONTENT',
          content: contentElement.innerHTML,
          autoPrint: true
        }, '*');
      });
    } else {
      alert('Pop-up blocat! Te rugăm să permiți pop-up-urile pentru această pagină.');
    }
  };

  const [dateRange, setDateRange] = React.useState(null);

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleExport = () => {
    if (dateRange) {
      const startDate = dateRange[0].format("YYYY-MM-DD");
      const endDate = dateRange[1].format("YYYY-MM-DD");
      const startDateFormat = dateRange[0].format("DD.MM.YYYY");
      const endDateFormat = dateRange[1].format("DD.MM.YYYY");
      setStartDateFormat(startDateFormat);
      setEndDateFormat(endDateFormat);
      setStartDate(startDate);
      setEndDate(endDate);
      setLoading(true);
      setLoading(false);
      setFinish(true);
      //   setTimeout(() => {
      //     setLoading(false);
      //     setFinish(true);
      //   }, [4 * 60000]);
      // Aici poți adăuga logica pentru exportul efectiv al condicii
    } else {
    }
  };

  const [profesori, setProfesori] = useState(true);
  return (
    <div>
      <h2>Selectează intervalul pentru exportul condicii</h2>
      <Switch
        checkedChildren="Profesori"
        unCheckedChildren="Administrativ"
        checked={profesori}
        onChange={(e) => setProfesori(e)}
      />
      <Switch
        checkedChildren="Per cadru"
        unCheckedChildren="Per zi"
        checked={perCadru}
        onChange={(e) => setPerCadru(e)}
      />
      <Switch
        checkedChildren="Include vacantele"
        unCheckedChildren="Nu include vacantele"
        checked={vacante}
        onChange={(e) => setVacante(e)}
      />
      <RangePicker
        onChange={handleDateChange}
        style={{ marginBottom: 20 }}
        format="YYYY-MM-DD"
      />
      {process.env.REACT_APP_NAME ===
        `Școala Gimnazială "Mihai Eminescu" Năsăud` && (
        <Switch
          checkedChildren="Valea Spinului"
          unCheckedChildren="Centru"
          checked={valeaSpinului}
          onChange={(e) => setValeaSpinului(e)}
        />
      )}
      {loading === false && (
        <Button type="primary" onClick={handleExport}>
          Exportă Condica
        </Button>
      )}
      {loading === true && <p>Se incarca, dureaza aproximativ 4 minute</p>}

      <div
        style={{
          display: "block",
          position: "relative",
          opacity: 1,
          height: "auto",
          overflow: "visible",
        }}
      >
        <div ref={componentRef} style={{ width: "100%", minHeight: "auto" }}>
          <div className="print-content">
            <br />
            <br />
            <div
              style={{
                marginTop: "50%",
                textAlign: "center",
                pageBreakAfter: "always",
              }}
            >
              <h1>{settings?.numeInstitutie}</h1>

              <h3>Condică de prezență</h3>
              <h4>
                {startDateFormat} - {endDateFormat}
              </h4>
            </div>
            <br />
            {startDate && endDate && (
              <CondicaExport
                vacante={vacante}
                perCadru={perCadru}
                startDate={startDate}
                endDate={endDate}
                condicaProfi={profesori}
                valeaSpinului={valeaSpinului}
              />
            )}
            {(!startDate || !endDate) && (
              <div>Debug: startDate={startDate?.toString()}, endDate={endDate?.toString()}</div>
            )}
          </div>
        </div>
        {finish === true && (
          <Button
            type="primary"
            onClick={() => {
              console.log('componentRef.current:', componentRef.current);
              console.log('innerHTML length:', componentRef.current?.innerHTML?.length);
              console.log('Has tables:', componentRef.current?.querySelectorAll('table').length);
              
              // Verify content exists before printing
              const contentElement = componentRef.current;
              if (!contentElement || contentElement.innerHTML.length < 1000) {
                alert('Conținutul nu este încărcat complet. Te rugăm să aștepți câteva secunde și încearcă din nou.');
                return;
              }
              
              handlePrint();
            }}
          >
            Descarca
          </Button>
        )}
      </div>
    </div>
  );
}

export default CondicaPanel;
